import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  Text,
} from "@chakra-ui/react";

import { CloseIcon } from "@/components/icons";
import { GoIcon } from "@/components/icons";
import { LogsButton } from "@/components/Button";
import { useNavigate } from "react-router-dom";
import { useUserInfo } from "@/context/UserInfo";
import { shortenAddress } from "@/utils";
import { avatarImg } from "@/utils/avatars";

const SetDrawer = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const { orgName, senderAddress, avatarIndex } = useUserInfo();

  const handleToMyInfo = () => {
    navigate("/myInfo");
  };

  return (
    <Drawer
      isOpen={isOpen}
      placement="bottom"
      onClose={onClose}
      autoFocus={false}
    >
      <DrawerOverlay />
      <DrawerContent
        sx={{
          borderRadius: "20px 20px 0 0",
          padding: "30px 20px 100px",
          background: "#FFF",
          position: "relative",
        }}
      >
        <DrawerBody
          sx={{
            padding: "0",
            position: "relative",
          }}
        >
          <CloseIcon
            onClick={onClose}
            style={{
              position: "absolute",
              top: "4px",
              right: "0",
              width: "16px",
              height: "16px",
              cursor: "pointer",
              color: "#333",
              transform: "",
            }}
          ></CloseIcon>
          <Text
            sx={{
              textAlign: "center",
              color: "#A44A25",
              fontFamily: "DIN",
              fontSize: "24px",
              fontWeight: 700,
            }}
          >
            Settings
          </Text>
          <LogsButton
            onClick={handleToMyInfo}
            sx={{
              marginTop: "66px",
              padding: "0 30px",
              width: "100%",
            }}
          >
            <Text
              sx={{
                fontSize: "38px",
                marginRight: "10px",
              }}
            >
              {avatarImg(avatarIndex)}
            </Text>
            <Box sx={{ textAlign: "left" }}>
              <Text
                sx={{
                  fontSize: "16px",
                }}
              >
                {orgName}
              </Text>
              <Text
                sx={{
                  fontSize: "14px",
                }}
              >
                {shortenAddress(senderAddress)}
              </Text>
            </Box>
            <GoIcon
              style={{
                marginLeft: "auto",
              }}
            ></GoIcon>
          </LogsButton>
          {/* <LogsButton
            variant="outlined"
            sx={{
              marginTop: "22px",
              padding: "0 30px",
            }}
          >
            <Image
              src={MemberIcon}
              sx={{
                width: "35px",
              }}
            ></Image>
            <Text
              sx={{
                fontSize: "16px",
                margin: "auto",
                fontWeight: 500,
              }}
            >
              Member Management
            </Text>
            <GoIcon></GoIcon>
          </LogsButton> */}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default SetDrawer;
